import { useMutation } from '@tanstack/react-query';
import { appelApi } from './api';
import type { UtilisateurConnecte } from './types';

export interface EntreeModifierProfil {
  nom?: string;
  prenom?: string;
  telephone?: string;
}

export interface EntreeChangerEmail {
  motDePasseActuel: string;
  nouvelEmail: string;
}

export interface EntreeModifierPreferences {
  alertesEmail?: boolean;
  alertesSms?: boolean;
  recapHebdo?: boolean;
  mfaActif?: boolean;
}

export interface ExportDonnees {
  profil: {
    id: string;
    email: string;
    nom: string;
    prenom: string;
    telephone: string | null;
    profil: string;
    sousProfil: string | null;
    creeLe: string;
    dernierAcces: string | null;
  };
  notifications: { titre: string; corps: string; canal: string; envoyeeLe: string }[];
}

export function useModifierProfil() {
  return useMutation({
    mutationFn: (entree: EntreeModifierProfil) =>
      appelApi<{ utilisateur: UtilisateurConnecte }>('/parametres/profil', {
        methode: 'PATCH',
        corps: entree,
      }),
  });
}

export function useChangerEmail() {
  return useMutation({
    mutationFn: (entree: EntreeChangerEmail) =>
      appelApi<{ utilisateur: UtilisateurConnecte }>('/parametres/email', {
        methode: 'PATCH',
        corps: entree,
      }),
  });
}

export function useChangerMotDePasse() {
  return useMutation({
    mutationFn: (entree: { motDePasseActuel: string; nouveauMotDePasse: string }) =>
      appelApi<{ modifie: true }>('/parametres/mot-de-passe', {
        methode: 'PATCH',
        corps: entree,
      }),
  });
}

export function useModifierPreferences() {
  return useMutation({
    mutationFn: (entree: EntreeModifierPreferences) =>
      appelApi<{ utilisateur: UtilisateurConnecte }>('/parametres/preferences', {
        methode: 'PATCH',
        corps: entree,
      }),
  });
}

export function useExporterDonnees() {
  return useMutation({
    mutationFn: () => appelApi<ExportDonnees>('/parametres/export'),
  });
}

export function useDemanderSuppression() {
  return useMutation({
    mutationFn: () =>
      appelApi<{ enregistree: true }>('/parametres/demande-suppression', { methode: 'POST' }),
  });
}
